import React, { useRef, useEffect } from 'react';
import { Form, Input } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import ModuleView from '../../ModuleView';

const FormItem = Form.Item;

function Certificate(props) {
  const formRefs = useRef<any[]>([]);
  const { type, data } = props;
  const { campusResumeFormRefStore, socialResumeFormRefStore, socialResumeDetail, campusResumeDetail } = useRootStore();

  let store;
  let storeRef;
  if (type === 'campus') {
    store = campusResumeDetail;
    storeRef = campusResumeFormRefStore;
  }
  if (type === 'social') {
    store = socialResumeDetail;
    storeRef = socialResumeFormRefStore;
  }

  /**
   * 初始化
   */
  useEffect(() => {
    storeRef.changeRef('resumeCertificateListRef', formRefs.current);
  }, [data, data?.length]);

  /**
   * 修改表单值同步更新store的值
   */
  const handleValueChange = (index: string, formItemKey: string, formItemValue: any) => {
    store.setResumeCertificateList(index, formItemKey, formItemValue);
  };

  return (
    <div className="certificate_edit model_edit">
      <div className="model_title">证书</div>
      {data?.map((item, index) => (
        <div className="model_list" key={item.renderId}>
          <Form
            ref={(el) => {
              formRefs.current[index] = el;
            }}
            className="modal_form"
            defaultFieldsValue={item}
            onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(index, formItemKey, formItemValue)}
          >
            <FormItem formItemKey="name" span="11" labelWidth={0}>
              <div className="label">证书名称</div>
              <Input toFormItem size="large" placeholder="请输入证书名称" maxLength={200} />
            </FormItem>
          </Form>
          <div className="delete-list">
            <div onClick={() => store.deleteResumeList('resumeCertificateList', index)}>删除这段信息</div>
          </div>
        </div>
      ))}
      <div
        className="list_add"
        onClick={() => {
          store.addResumeList('resumeCertificateList');
        }}
      >
        <div className="add_icon">
          <img src={require('@imgs/add.svg')} alt="" />
        </div>
        添加证书
      </div>
    </div>
  );
}

export default ModuleView(observer(Certificate), 'certificate');
